<template>
  <div
    class="bb-company-form"
    @click="setShowDetailsLinkPopup(-1)"
  >
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <div class="bb-company-form-header">
      <div class="bb-company-form-header-avatar-wrapper">
        <img class="bb-company-form-header-avatar-wrapper__avatar"
             :src="(company.image || imgSrc) ? company.image.path || imgSrc : companyImageDefault"
        />
        <img
          class="bb-company-form-header-avatar-wrapper__edit"
          src="@/assets/images/icon-photo.png"
        />
        <input class="bb-company-form-header-avatar-wrapper__input"
               accept="image/*"
               @click.stop
               @change="processFile"
               type="file"
        />
      </div>
    </div>
    <div class="bb-company-form-body">
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Name
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          :class="{'bb-input_error': errorField === 'companyTitle'}"
          autocomplete="off"
          v-model="company.name"
          v-autofocus
        />
        <!-- errors -->
        <transition name="fade">
          <span
            class="bb-input-error-text"
            v-if="errorField === 'companyTitle'"
          >
            mandatory field
          </span>
        </transition>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Website
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.website"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Email Domain
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.emailDomain"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Client Id
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.clientId"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Client Secret
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.clientSecret"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Phone
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.phone"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Skype
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.skype"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Whatsapp
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.whatsapp"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-form__label_top bb-company-form-body-item__label">
          Address
        </div>
        <textarea
          class="bb-company-form-body-item__textarea bb-input bb-input_border"
          v-model="company.address"
        >
        </textarea>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-form__label_top bb-company-form-body-item__label">
          Social media
        </div>
        <div class="bb-company-form-body-item__right">
          <transition-group
            tag="div"
            name="fade"
            class="bb-company-form-body-email"
            v-if="company.socialMedia.length"
            mode="out-in"
          >
            <div
              class="bb-company-form-body-email__item"
              v-for="(item, index) in company.socialMedia"
              :key="item._id"
            >
              <div class="bb-company-form-body-item-input-wrap">
                <div
                  class="bb-company-form-body-item-input-wrap__icon"
                  v-html="getSocialIcon(item.mediaType)"
                />
                <input
                  type="text"
                  class="bb-company-form-body-item__input bb-input bb-input_border"
                  autocomplete="off"
                  :class="{'bb-company-form-body-item__input_email': true}"
                  v-model="item.link"
                >
              </div>
              <div class="bb-company-form-body-email-add"
                   @click.stop="removeSocialMedia(index)"
              >

                <i class="icon-minus bb-company-form-body-email-add__minus"/>
              </div>
            </div>
          </transition-group>
          <div
            class="bb-company-add-social-media"
            @click.stop="showChangeSocialType"
          >
            <i class="icon-cross bb-company-add-social-media__icon"/>
            Add social media
            <transition name="bounce">
              <div
                v-if="openChangeSocialType"
                class="bb-company-form-body-item-social"
                @mouseleave="openChangeSocialType = false"
                v-click-outside="() => { openChangeSocialType = false}"
                :style="styleChangeSocialType"
              >
                <div class="bb-company-form-body-item-social__wrap">
                  <div
                    class="bb-company-social-item"
                    v-for="social in socialMediaList"
                    :key="social.mediaType"
                    @click.stop="addSocialMedia(social.mediaType)"
                  >
                    <div
                      class="bb-company-social-item__icon"
                      v-html="social.icon"
                    />
                    <div class="bb-company-social-item__title">
                      {{ social.title }}
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">Commercial offer</div>
        <div class="bb-company-form-body-item__right bb-company-form-body-item__right_row">
          <div class="bb-company-form-body-item-radio">
            <radio
              class="bb-company-form-body-item-radio__field"
              name="commercialOfferType"
              @radioChange="($event) => radioChange($event, 'commercialOfferType')"
              radio-text="1 type"
              value="1"
              :checked="company.commercialOfferType === 1"
            />
            <div
              class="bb-company-form-body-item-radio-icon"
            >
              <i v-html="eyeIcon"></i>
              <div class="bb-company-form-body-item-radio-icon-placeholder">
                <img src="@/assets/images/kp1.jpg">
              </div>
            </div>
          </div>
          <div class="bb-company-form-body-item-radio">
            <radio
              class="bb-company-form-body-item-radio__field"
              name="commercialOfferType"
              @radioChange="($event) => radioChange($event, 'commercialOfferType')"
              radio-text="2 type"
              value="2"
              :checked="company.commercialOfferType === 2"
            />
            <div
              class="bb-company-form-body-item-radio-icon"
            >
              <i v-html="eyeIcon"></i>
              <div class="bb-company-form-body-item-radio-icon-placeholder">
                <img src="@/assets/images/kp2.jpg">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Commercial offer domain
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          :class="{'bb-input_error': errorField === 'url'}"
          autocomplete="off"
          v-model="company.url"
        />
        <!-- errors -->
        <transition name="fade">
          <span
            class="bb-input-error-text"
            v-if="errorField === 'url'"
          >
             Enter url like https://domain.com
          </span>
        </transition>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Commercial offer <br>company name
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.commercialOfferCompanyNameRU"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Commercial offer <br>second company name
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.commercialOfferCompanyNameEN"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Prefix service
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          :class="{'bb-input_error': errorField === 'serviceName'}"
          autocomplete="off"
          maxlength="10"
          v-model="company.serviceName"
          v-autofocus
        />
        <transition name="fade">
          <span
            class="bb-input-error-text"
            v-if="errorField === 'serviceName'"
          >
            mandatory field
          </span>
        </transition>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">Signature</div>
        <div class="bb-company-form-body-item__right bb-company-form-body-item__right_row">
          <div class="bb-company-form-body-item-radio">
            <radio
              class="bb-company-form-body-item-radio__field"
              name="signatureType"
              @radioChange="($event) => radioChange($event, 'signatureType')"
              radio-text="1 type"
              value="1"
              :checked="company.signatureType === 1"
            />
            <div
              class="bb-company-form-body-item-radio-icon"
            >
              <i v-html="eyeIcon"></i>
              <div class="bb-company-form-body-item-radio-icon-placeholder">
                <img src="@/assets/images/signature1.jpg">
              </div>
            </div>
          </div>
          <div class="bb-company-form-body-item-radio">
            <radio
              class="bb-company-form-body-item-radio__field"
              name="signatureType"
              @radioChange="($event) => radioChange($event, 'signatureType')"
              radio-text="2 type"
              value="2"
              :checked="company.signatureType === 2"
            />
            <div
              class="bb-company-form-body-item-radio-icon"
            >
              <i v-html="eyeIcon"></i>
              <div class="bb-company-form-body-item-radio-icon-placeholder">
                <img src="@/assets/images/signature2.jpg">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label bb-form__label_top">
          Details
        </div>
        <div class="bb-company-form-body-item__right">
          <transition-group
            tag="div"
            name="fade"
            class="info-link-list"
            v-if="company.details.length"
            mode="out-in"
          >
            <div
              v-for="(item, i) in company.details"
              :key="item._id"
              class="info-link-list-wrap"
            >
              <div class="info-link-block">
                <input
                  type="text"
                  class="info-link-block__input bb-input bb-input_border"
                  autocomplete="off"
                  v-model="item.text"
                >
                <div
                  class="info-link-block__icon"
                  @mouseenter="hoverDetailsLink = i"
                  @mouseleave="hoverDetailsLink = -1"
                  @click.stop="setShowDetailsLinkPopup(i)"
                >
                  <i v-html="linkIcon"></i>
                  <transition name="bounce">
                    <BBTooltip
                      v-if="hoverDetailsLink === i && showDetailsLinkPopup !== i"
                      :textToolTip="item.link || 'Create link'"
                    />
                  </transition>
                  <transition name="bounce">
                    <div
                      v-if="showDetailsLinkPopup === i"
                      class="info-link-block-popup"
                      @click.stop
                    >
                      <input
                        :placeholder="'Type or paste URL'"
                        v-model="item.link"
                        @keydown.enter="showDetailsLinkPopup = -1; hoverDetailsLink = -1"
                        class="info-link-block-popup__input"
                      />
                    </div>
                  </transition>
                </div>
              </div>
              <div class="bb-company-form-body-email-add"
                   @click.stop="i === company.details.length - 1
                   ? addedDetailsLink('details', 'link')
                   : removeDetailsLink(i, 'details')"
              >
                <i
                  :class="i === company.details.length - 1
                    ? 'bb-company-form-body-email-add__icon  icon-cross'
                    : 'bb-company-form-body-email-add__minus icon-minus'"
                />

              </div>
            </div>
          </transition-group>
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">Invoice</div>
        <div class="bb-company-form-body-item__right bb-company-form-body-item__right_row">
          <div class="bb-company-form-body-item-radio">
            <radio
              class="bb-company-form-body-item-radio__field"
              name="invoiceType"
              @radioChange="($event) => radioChange($event, 'invoiceType')"
              radio-text="1 type"
              value="1"
              :checked="company.invoiceType === 1"
            />
            <div
              class="bb-company-form-body-item-radio-icon"
            >
              <i v-html="eyeIcon"></i>
              <div class="bb-company-form-body-item-radio-icon-placeholder">
                <img src="@/assets/images/invoice1.jpg">
              </div>
            </div>
          </div>
          <div class="bb-company-form-body-item-radio">
            <radio
              class="bb-company-form-body-item-radio__field"
              name="invoiceType"
              @radioChange="($event) => radioChange($event, 'invoiceType')"
              radio-text="2 type"
              value="2"
              :checked="company.invoiceType === 2"
            />
            <div
              class="bb-company-form-body-item-radio-icon"
            >
              <i v-html="eyeIcon"></i>
              <div class="bb-company-form-body-item-radio-icon-placeholder">
                <img src="@/assets/images/invoice2.jpg">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          invoice prefix
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.invoicePrefix"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          assets inventory No prefix
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.assetsInvNoPrefix"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Terms & conditions <br>company title
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.invoiceTerms"
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Show tax invoice
        </div>
        <div class="bb-company-form-body-item__right">
          <toggle
            @toggleChange="handlerChangeTaxInvoice"
            :name="'isTaxInvoice'"
            :value="company.isTaxInvoice"
            type="accent-small"
          />
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label bb-form__label_top">
          Invoice details
        </div>
        <div class="bb-company-form-body-item__right">
          <transition-group
            tag="div"
            name="fade"
            class="info-link-list"
            v-if="company.invoiceDetails.length"
            mode="out-in"
          >
            <div
              v-for="(item, i) in company.invoiceDetails"
              :key="item._id"
              class="info-link-list-wrap"
            >
              <div class="info-link-block">
                <input
                  type="text"
                  class="info-link-block__input bb-input bb-input_border"
                  autocomplete="off"
                  v-model="item.text"
                >
              </div>
              <div class="bb-company-form-body-email-add"
                   @click.stop="i === company.invoiceDetails.length - 1
                   ? addedDetailsLink('invoiceDetails')
                   : removeDetailsLink(i, 'invoiceDetails')"
              >
                <i
                  :class="i === company.invoiceDetails.length - 1
                    ? 'bb-company-form-body-email-add__icon  icon-cross'
                    : 'bb-company-form-body-email-add__minus icon-minus'"
                />

              </div>
            </div>
          </transition-group>
        </div>
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          {{HR_EMAIL}}
          <HelpPopup
            :text="HR_EMAIL_POPUP_TEXT"
            addClassPopup="type-big"
          />
        </div>
        <input
          type="text"
          class="bb-company-form-body-item__input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.hrNotificationEmail"
          v-autofocus
        />
      </div>
      <div class="bb-company-form-body-item">
        <div class="bb-form__label bb-company-form-body-item__label">
          Client List Email
        </div>
        <input
          type="text"
          class="bb-company-form-body-item_k_input bb-input bb-input_border"
          autocomplete="off"
          v-model="company.clientNotification"
          v-autofocus
        />
      </div>
      <ContactFormMailing
        v-if="company.id"
        :title="MALLING_SERVICE_SETTING"
        :textHelperPopup="MALLING_SERVICE_SETTING_POPUP_TEXT"
        addClassPopup="type-big"
        :company="company"
        :type="contactFormMailing"
      />
      <ContactFormMailing
        v-if="company.id"
        :title="PROJECT_NOTIFICATIONS_PM_DEPT"
        :textHelperPopup="PROJECT_NOTIFICATIONS_PM_DEPT_POPUP_TEXT"
        addClassPopup="type-big"
        :company="company"
        :type="contactFormProject"
      />
      <ContactFormMailing
        v-if="company.id"
        :title="ACADEMY_NOTIFICATIONS_COURSE"
        addClassPopup="type-big"
        :company="company"
        :type="contactFormAcademy"
      />
      <ContactFormMailing
        v-if="company.id"
        :title="EMAIL_HR_NOTIFICATIONS"
        :textHelperPopup="EMAIL_HR_NOTIFICATIONS_POPUP_TEXT"
        addClassPopup="type-big"
        :company="company"
        :type="contactFormHr"
      />
      <ContactFormMailing
        v-if="company.id"
        :title="EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS"
        :textHelperPopup="EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS_POPUP_TEXT"
        addClassPopup="type-big"
        :company="company"
        :type="contactFormClient"
      />
    </div>
    <ModalWindow v-if="file" @close="file = false" @click.stop>
      <UploadImage :file="file" @uploadFile="setFileData" @click.stop/>
    </ModalWindow>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import radio from '@/components/Main/Inputs/radio'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { get, set, uniqueId } from 'lodash'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import UploadImage from '@/components/Main/UploadImage/UploadImage'
import UploadFileApi from '@/api/UploadFile/api'
import logoCompanyDefault from '@/assets/images/avatar-company-default-big.png'
import toggle from '@/components/Main/Inputs/toggle'
import { EyeIcon, LinkIcon } from '@/constants/icon'
import {
  MALLING_SERVICE_SETTING,
  MALLING_SERVICE_SETTING_POPUP_TEXT,
  HR_EMAIL,
  HR_EMAIL_POPUP_TEXT,
  EMAIL_HR_NOTIFICATIONS,
  EMAIL_HR_NOTIFICATIONS_POPUP_TEXT,
  PROJECT_NOTIFICATIONS_PM_DEPT,
  PROJECT_NOTIFICATIONS_PM_DEPT_POPUP_TEXT,
  EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS,
  EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS_POPUP_TEXT,
  ACADEMY_NOTIFICATIONS_COURSE,
} from '@/constants/companyFormText'
import { CONTACT_FORM_MAILING, CONTACT_FORM_HR, CONTACT_FORM_CLIENT, CONTACT_FORM_PROJECT, CONTACT_FORM_ACADEMY } from '@/constants/contactFormServices'
import SOCIAL_MEDIA_LIST from '../../../../constants/socialMedia'
import BBTooltip from '../../../Main/BBTooltip/BBPTooltip'
import ContactFormMailing from '@/components/Settings/Companies/CompanyForm/ContactFormMailing/ContactFormMailing'
import HelpPopup from "./HelpPopup/HelpPopup.vue";


export default {
  name: 'ContactForm',
  props: {
    errorField: {
      type: String,
      default: ''
    },
    company: {
      type: Object,
      default: () => ({}),
    }
  },
  components: {
    ContactFormMailing,
    radio,
    VuePerfectScrollbar,
    ModalWindow,
    UploadImage,
    BBTooltip,
    LoaderFly,
    toggle,
    HelpPopup,
  },
  data: function () {
    return {
      openChangeSocialType: false,
      socialMediaList: SOCIAL_MEDIA_LIST,
      eyeIcon: EyeIcon(),
      linkIcon: LinkIcon(),
      hoverDetailsLink: -1,
      showDetailsLinkPopup: -1,
      loaderRun: false,
      file: false,
      imgSrc: false,
      companyImageDefault: logoCompanyDefault,
      crypt: false,
      styleChangeSocialType: {
        top: 0,
        left: 0
      },
      isShowCheck: false,
      contactFormMailing: CONTACT_FORM_MAILING,
      contactFormHr: CONTACT_FORM_HR,
      contactFormClient: CONTACT_FORM_CLIENT,
      contactFormProject: CONTACT_FORM_PROJECT,
      contactFormAcademy: CONTACT_FORM_ACADEMY,
      MALLING_SERVICE_SETTING,
      MALLING_SERVICE_SETTING_POPUP_TEXT,
      HR_EMAIL,
      HR_EMAIL_POPUP_TEXT,
      EMAIL_HR_NOTIFICATIONS,
      EMAIL_HR_NOTIFICATIONS_POPUP_TEXT,
      PROJECT_NOTIFICATIONS_PM_DEPT,
      PROJECT_NOTIFICATIONS_PM_DEPT_POPUP_TEXT,
      EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS,
      EMAIL_CLIENT_TRACKING_LIST_NOTIFICATIONS_POPUP_TEXT,
      ACADEMY_NOTIFICATIONS_COURSE,
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    handlerChangeTaxInvoice (data) {
      this.company.isTaxInvoice = data
    },
    showChangeSocialType (e) {
      const { target } = e
      const { y, x } = target.getBoundingClientRect()
      const { innerHeight } = window
      const topPosition = y + 20
      const numberSocial = this.socialMediaList.length
      const heightSocialBlock = numberSocial * 19 + 24 + (numberSocial - 1) * 8
      const top = heightSocialBlock + topPosition + 20 > innerHeight
        ? `${topPosition - heightSocialBlock - 30}px`
        : `${topPosition}px`
      const left = `${x}px`
      this.styleChangeSocialType = {
        top,
        left
      }
      this.openChangeSocialType = true
    },
    radioChange (data, key) {
      this.company[key] = +data
    },
    addedDetailsLink (key, link) {
      this.company[key].push(
        {
          _id: uniqueId(),
          text: '',
          link: link ? '' : undefined
        }
      )
    },
    removeDetailsLink (i, key) {
      this.company[key].splice(i, 1)
    },
    setShowDetailsLinkPopup (value) {
      this.showDetailsLinkPopup = this.showDetailsLinkPopup !== value ? value : -1
    },
    uploadFile (fileData) {
      this.loaderRun = true
      UploadFileApi.createFile(fileData, this.crypt)
        .then(({data}) => {
          this.company.image = data
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    setFileData (fileData, file) {
      const { id = 'new' } = this.company
      const label = fileData.get('file').name
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', label)
      fileData.set('parentId', id)
      fileData.set('onModel', 'Client')
      this.file = false
      this.imgSrc = file || this.imgSrc
      const cacheImage = new Image()
      cacheImage.src = this.imgSrc
      set(this.company, 'image.path', this.imgSrc)
      this.uploadFile(fileData)
    },
    processFile (e) {
      const files = get(e, 'target.files', [])
      if (!files.length) return
      this.file = files[0]
      e.target.value = ''
    },
    addSocialMedia (mediaType) {
      this.openChangeSocialType = false
      this.company.socialMedia.push({
        mediaType,
        link: '',
        _id: uniqueId()
      })
    },
    removeSocialMedia (index) {
      this.company.socialMedia.splice(index, 1)
    },
    getSocialIcon (mediaType) {
      const currentSocial = this.socialMediaList.find((item) => item.mediaType === mediaType) || {}
      const { icon } = currentSocial
      return icon
    },
    setLoader (value) {
      this.loaderRun = value
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-company-form {
  @include global-font;
  position: relative;
  display: grid;
  grid-template-rows: 150px auto;
  grid-gap: 43px;
  width: 533px;
  background: $color-white;
  border-radius: 5px;
  font-size: 12px;
  z-index: 1;

  &-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color-wild-sand;
    min-height: 55px;
    padding: 0 20px;

    &__title {
      color: $color-accent;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
    }

    &-toolbar {
      display: grid;
      grid-template-columns: 25px 25px;
      grid-gap: 6px;
    }
  }

  &-header {
    display: flex;
    margin: 5px 20px 0 25px;
    justify-content: center;

    &-avatar-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      margin-right: 29px;
      height: 111px;

      &__avatar {
        width: 111px;
        height: 111px;
        border-radius: 50%;
      }

      &__input,
      &__edit {
        position: absolute;
        bottom: -6px;
        width: 30px;
        height: 30px;
        font-size: 0;
        cursor: pointer;
      }

      &__vip {
        color: $color-accent;
        font-size: 20px;
        width: 20px;
        height: 20px;
        margin-left: 2px;
      }

      &__input {
        opacity: 0;
      }
    }

    &-user-info {
      width: 100%;

      &-totals {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        margin-right: -10px;
      }

      &__fullname {
        display: flex;
        align-items: center;
        color: $color-black;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 12px;
      }

      &__code {
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $color-gray;
        font-weight: 600;
        font-size: 11px;
        line-height: 13px;
        padding: 6px 11px;
        width: 100%;
        background-color: $color-white;
      }

      &__balance {
        flex-grow: 1;
        white-space: nowrap;
        padding: 10px 12px;
        background: rgba($color-silver-chalice, 0.2);
        border-radius: 7px;
        color: $color-gray;
        font-size: 13px;
        line-height: 16px;
        font-weight: 600;
        margin-right: 10px;
        cursor: pointer;
        margin-bottom: 10px;

        &_negative {
          color: $color-pomegranate;
          background-color: $color-cinderella;
        }

        &_positive {
          color: $color-japanese-laurel;
          background-color: rgba($color-japanese-laurel, 0.2);
        }

        i {
          margin-right: 4px;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }

    &-new-proforma {
      position: relative;
      display: flex;
      align-items: center;

      &__button {
        width: 100%;
        height: 36px;
        font-weight: 600;
        font-size: 11px;
        color: $color-white;
      }
    }
  }

  &-body {
    position: relative;
    display: flex;
    flex-direction: column;
    grid-gap: 18px;

    &-email {
      display: flex;
      justify-content: center;
      flex-direction: column;
      flex-grow: 1;
      grid-gap: 16px;

      &-social {
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: 32px;
        margin-left: 8px;
        cursor: pointer;
        color: $color-dusty-gray;

        i:before {
          margin: 0;
        }
      }

      &__item {
        position: relative;
        display: grid;
        grid-template-columns: auto 30px;
        align-items: center;
        grid-gap: 8px;
        width: 100%;

        &:last-child {
          margin-bottom: 0;
        }

        &_residential {
          align-items: flex-start;
        }
      }

      &__menu {
        padding: 10px;
        position: absolute;
        transform: rotate(90deg);
        color: $color-accent;
        right: 41px;
        cursor: pointer;

        &:hover {
          color: $color-accent-hover;
        }
      }

      &-add {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid $color-wild-sand;
        box-sizing: border-box;
        border-radius: 5px;
        min-width: 30px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        flex-basis: 30px;

        &:hover &__icon {
          color: $color-accent-hover;
        }

        &:hover &__minus {
          color: $color-accent-hover;
        }

        &__icon {
          color: $color-accent;
          transform: rotate(45deg);
        }

        &__minus {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2px;
          color: $color-accent;
        }
      }
    }

    &-residential {
      border: 1px dashed $color-seashell;
      box-sizing: border-box;
      border-radius: 5px;
      margin: 9px 25px 9px 15px;
      transition: 0.3s;

      &_view-mode {
        border-color: transparent;
        margin: 0;
      }
    }

    &-item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 30px;
      font-size: 12px;
      line-height: 14px;

      &__right {
        display: flex;
        flex-direction: column;
        width: 100%;
        grid-gap: 16px;

        &_row {
          flex-direction: row;
          grid-gap: 44px;
        }

      }

      &__file {
        margin-right: auto;
        margin-left: 0;
        transition: 0.3s;

        &_view-mode {
          margin-right: 0;
          margin-left: auto;
        }
      }

      &_residential {
        position: relative;
        padding: 10px;
        margin: 0;
      }

      &_file {
        align-items: center;
      }

      &__label {
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        min-width: 180px;
      }

      &_select {
        height: 30px;
      }

      &_textarea {
        height: 82px;
        align-items: flex-start;

        &_disable {
          height: 82px;
        }
      }

      &__input {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        font-size: 12px;

        &__text {
          margin-left: 6px;
        }

        &_select {
          height: 32px;
        }

        &_email {
          height: 32px;
          max-height: 32px;
          flex-basis: 89%;
        }

        &_capitalize {
          text-transform: capitalize;
        }
      }

      &_text-error {
        position: absolute;
        right: 32px;
        color: $color-red-orange;
        font-size: 11px;
        line-height: 13px;

        &_address {
          bottom: 20px;
          right: 10px;
        }

        &_email {
          right: 45px;
        }
      }

      &__text {
        padding: 9px 11px 9px 16px;

        &_country {
          display: grid;
          grid-template-columns: 22px auto;
          grid-gap: 5px;
          align-items: center;
        }
      }

      &__phones {
        display: flex;
        align-items: center;
        min-height: 20px;
      }

      &__social {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        color: $color-silver-chalice
      }

      &__viber-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      .icon-telegram {
        color: $color-accent-hover;
        font-size: 12px;
      }

      .icon-whatsapp {
        color: $color-mountain-meadow;
        font-size: 14px;
      }

      .icon-viber {
        position: relative;
        color: $color-white;
        font-size: 18px;
        z-index: 1;
      }

      .icon-viber-background {
        font-size: 16px;
        position: absolute;
        color: $color-wisteria;
      }

      &-date {
        display: flex;
        align-items: center;

        &__clear {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          min-width: 30px;
          min-height: 30px;
          border-radius: 5px;
          border: 1px solid $color-wild-sand;
          color: $color-accent;
          margin-left: 10px;
          cursor: pointer;

          &:hover {
            color: $color-accent-hover;
          }
        }

        &__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          margin-left: 5px;
          color: $color-accent;
        }
      }

      &__textarea {
        resize: none;
        width: 100%;
        font-size: 12px;
        height: 82px;
      }

      &-countries {
        display: grid;
        grid-template-columns: 22px auto;
        grid-gap: 5px;
        align-items: center;

        &_selected {
          height: 32px;
        }

        &_bank {
          line-height: 28px;
          grid-template-columns: auto;
        }
      }
    }

    &-settings {
      padding: 10px;
      border: 1px dashed $color-mercury;
      border-radius: 5px;
      margin: -12px 0 0 0;
      position: relative;

      &__title {
        font-size: 13px;
        font-weight: 600;
        margin: 10px 0 0 0;
      }

      &-item {
        display: flex;
        align-items: center;

        & + & {
          margin: 18px 0 0 0;
        }

        &__label {
          font-weight: 600;
          font-size: 13px;
          line-height: 16px;
          min-width: 180px;
        }
      }

      &__link {
        justify-content: flex-end;
        color: $color-denim;
        font-size: 12px;
        font-weight: 500;
        margin-top: 6px !important;
        text-decoration: underline;
        cursor: pointer;
        transition: 0.15s;
      }

      &-form {
        width: 100%;
        position: relative;

        &__input {
          position: relative;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          font-size: 12px;
        }
      }

      &__icon {
        color: $color-silver-new;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
        cursor: pointer;
        transition: 0.15s;
      }

      &__popup {
        position: absolute;
        top: -18px;
        right: -56px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        padding: 4px 5px 4px 5px;
        background: rgba($color-black, 0.55);
        font-weight: 500;
        font-size: 11px;
        line-height: 13px;
        text-align: center;
        color: $color-white;
        border-radius: 3px;
        z-index: 20;
        pointer-events: none;

        &:before {
          content: '';
          position: absolute;
          left: auto;
          bottom: -3px;
          display: block;
          width: 0;
          height: 0;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          border-top: 3px solid rgba($color-black, 0.55);
        }
      }

      &__error {
        top: 50%;
        transform: translateY(-50%) !important;
        right: 10px !important;
      }
    }

    &-checkboxes {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: start;
      transition: all .15s linear;
      line-height: 14px;
      text-transform: capitalize;
      min-height: 32px;
      background-color: $color-white;

      &_open {
        max-height: 120px;
        height: auto;
        min-height: 32px;
        z-index: 1;
      }

      &__checkboxMain {
        position: relative;
        display: flex;
        align-items: center;
        z-index: 1;
      }

      &__checkboxList {
        margin: 8px auto 0 auto;

        &:first-child {
          margin-top: 10px;
        }
      }

      &__arrow {
        position: absolute;
        right: 12px;
        font-size: 5px;
        color: $color-accent;
        transition: all .2s linear;
        cursor: pointer;
      }
    }

    &_view-mode {
      margin-top: 7px;

      .bb-company-form-body {
        &-item {
          align-items: flex-start;
          height: auto;
          min-height: auto;
          margin: 0 20px;
          padding: 13px 0;
          border-bottom: 1px solid $color-wild-sand;

          &_file {
            align-items: center;
          }

          &__text {
            font-weight: normal;
            font-size: 13px;
            line-height: 16px;
            padding: 0;

            pre {
              white-space: pre-wrap;
            }
          }

          &-date {
            height: 16px;
            margin-right: -12px;
          }

          &__label {
            margin: 0;
            padding: 0;
          }

          &__input {
            justify-content: flex-end;
          }
        }
      }
    }
  }

  &-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
    margin-bottom: 25px;
    width: 100%;

    &__add {
      width: 90px;
      box-sizing: border-box;
      border: 2px solid transparent;
      font-size: 13px;
      line-height: 16px;
    }
  }
}

.bb-company-social-item {
  display: flex;
  flex-wrap: nowrap;
  grid-gap: 12px;
  align-items: center;
  user-select: none;
  color: $color-text;
  font-weight: 400;
  transition: color .2s ease-in;

  &__icon {
    display: flex;
  }

  &__title {
    line-height: 1.5;
  }

  &:hover {
    color: $color-accent-hover;
  }
}

.bb-company-form-body-item-social {
  position: fixed;
  z-index: 2;
  box-shadow: 0 0 20px rgba($color-black, 0.05);
  border-radius: 3px;
  padding: 12px;
  background: $color-white;
  overflow: hidden;

  &__wrap {
    display: inline-flex;
    grid-gap: 8px;
    flex-direction: column;
    align-items: flex-start;
  }

}

.bb-company-add-social-media {
  position: relative;
  z-index: 3;
  display: flex;
  font-size: 13px;
  color: $color-accent;
  transition: color .2s ease-in;
  cursor: pointer;
  font-weight: 600;

  &__icon {
    transform: rotate(45deg);
  }

  &:hover {
    color: $color-accent-hover;
  }
}

.bb-company-form-body-item-input-wrap {
  position: relative;

  &__icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  .bb-company-form-body-item__input {
    padding-left: 36px;
  }

}

.bb-company-form-body-item-radio {
  display: flex;
  grid-gap: 6px;
  align-items: center;

  .bb-company-form-body-item-radio__field {
    margin-right: 0;
  }
}

.bb-company-form-body-item-radio-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $color-wild-sand;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  color: $color-accent;
  cursor: pointer;
  transition: color .2s ease-in;

  &:hover {
    color: $color-accent-hover;

    .bb-company-form-body-item-radio-icon-placeholder {
      opacity: 1;
    }

  }

}

.bb-company-form-body-item-radio-icon-placeholder {
  position: absolute;
  left: 50%;
  z-index: 3;
  transform: translateX(-50%);
  bottom: calc(100% + 11px);
  width: 215px;
  box-shadow: 0 0 12px rgba($color-black, 0.12);
  pointer-events: none;
  opacity: 0;
  transition: opacity.2s ease-in;

  img {
    display: block;
    max-width: 100%;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    z-index: -1;
    width: 12px;
    height: 12px;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
  }
}

.info-link-list {
  display: flex;
  flex-direction: column;
  grid-gap: 16px;
}

.info-link-block {
  position: relative;
  z-index: 2;

  &__input {
    width: 100%;
    padding-right: 36px;
  }

  &__icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
    cursor: pointer;
    color: $color-silver-new;
    transition: color .2s ease-in;

    &:hover {
      color: $color-accent-hover;
    }

    i {
      display: flex;
    }

  }

}

.info-link-list-wrap {
  display: grid;
  grid-template-columns: auto 30px;
  width: 100%;
  grid-gap: 8px;
}

.info-link-block-popup {
  position: absolute;
  bottom: calc(100% + 10px);
  right: -15px;
  min-width: 235px;
  background: $color-white;
  box-shadow: 0 0 12px rgba($color-black, 0.12);
  border-radius: 3px;

  &:after {
    content: "";
    position: absolute;
    bottom: -5px;
    right: 15px;
    width: 8px;
    height: 8px;
    z-index: 1;
    background: $color-white;
    transform: rotate(-45deg);
    box-shadow: 0 0 12px rgba($color-black, 0.12);
  }

  &__input {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 9px 10px;
    border: none;
    font-family: inherit;
    font-size: 12px;
    line-height: 120.34%;
    color: $color-tundora;
    border-radius: 3px;
    background-color: #fff;
  }

}

.bb-company-form-footer {
  display: flex;
  justify-content: center;

  .bb-button {
    text-transform: uppercase;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    color: $color-white;
    padding-left: 35px;
    padding-right: 35px;
  }
}

.bb-input-error-text {
  position: absolute;
  right: 32px;
  color: $color-red-orange;
  font-size: 11px;
  line-height: 13px;
}

</style>



// WEBPACK FOOTER //
// src/components/Settings/Companies/CompanyForm/CompanyForm.vue